import { Badge, Box, DataList, HoverCard, HStack, Text } from "@chakra-ui/react"
import React from "react"
import { format as formatDate } from "date-fns"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"

interface AIPlanCellHoverProps {
  plan?: gqlTypes.FulfilmentPlan
  children: React.ReactNode
  left?: number
  top?: number
  open?: boolean
}

const AIPlanCellHover = ({
  plan,
  children,
  left = 0,
  top = 0,
  open,
}: AIPlanCellHoverProps) => {
  return (
    <HoverCard.Root open={open} positioning={{ placement: "bottom-end" }}>
      <HoverCard.Trigger asChild>
        <Box
          position="fixed"
          left={`${left}px`}
          top={`${top}px`}
          width="1px"
          height="1px"
          visibility="hidden"
          pointerEvents="none"
        >
          {children}
        </Box>
      </HoverCard.Trigger>
      <HoverCard.Positioner zIndex={1000}>
        <HoverCard.Content p={3} maxW="320px">
          {plan && (
            <>
              <HStack mb={2}>
                <Badge colorScheme="purple" fontSize="xs">
                  AI
                </Badge>
                <Text fontSize="sm" fontWeight="semibold" color="primary">
                  Pending Fulfilment
                </Text>
              </HStack>
              <DataList.Root orientation="horizontal" gap={0}>
                <DataList.Item key="order">
                  <DataList.ItemLabel>Order:</DataList.ItemLabel>
                  <DataList.ItemValue>{plan.order.name}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item key="asset">
                  <DataList.ItemLabel>Asset:</DataList.ItemLabel>
                  <DataList.ItemValue>{plan.asset.name}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item key="quantity">
                  <DataList.ItemLabel>Quantity:</DataList.ItemLabel>
                  <DataList.ItemValue>{plan.quantity} kg</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item key="startDate">
                  <DataList.ItemLabel>Start Date:</DataList.ItemLabel>
                  <DataList.ItemValue>
                    {formatDate(new Date(plan.start), "dd/MM/yyyy HH:mm")}
                  </DataList.ItemValue>
                </DataList.Item>
                <DataList.Item key="endDate">
                  <DataList.ItemLabel>End Date:</DataList.ItemLabel>
                  <DataList.ItemValue>
                    {formatDate(new Date(new Date(plan.end).getTime() - 1000), "dd/MM/yyyy HH:mm")}
                  </DataList.ItemValue>
                </DataList.Item>
              </DataList.Root>
            </>
          )}
        </HoverCard.Content>
      </HoverCard.Positioner>
    </HoverCard.Root>
  )
}

export default AIPlanCellHover
